import React from "react";
import "./style.css";
import logoFoot from "../../Assets/Footer/logoFoot1.png";
import fb from "../../Assets/Footer/fb.png";
import ig from "../../Assets/Footer/ig.png";
import ln from "../../Assets/Footer/li.png";
import tt from "../../Assets/Footer/tt.png";
import location from "../../Assets/Contact/location.png";
import contact from "../../Assets/Contact/contact.png";
import mail from "../../Assets/Contact/mail.png";
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="footer-left">
          <div className="footer-logo mt-3">
            <img src={logoFoot} alt=" Logo" />
          </div>
          <div className="social-icons">
            <a
              href="https://www.facebook.com/people/Singapore-Security-Force-Pte-Ltd/61561041582916/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={fb} alt="Facebook Logo" />
            </a>
            <a
              href="https://www.instagram.com/singaporesecurityforce/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={ig} alt="Instagram Logo" />
            </a>

            <a
              href="https://www.tiktok.com/@singapore.securit?_t=ZS-8vjoy8JxKl8&_r=1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={tt} alt="Tiktok Logo" />
            </a>
          </div>
        </div>

        <div className="footer-right">
          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul>
  <li><Link to="/">Home</Link></li>
  <li><Link to="/about-us">About Us</Link></li>
  <li><Link to="/services">Our Services</Link></li>
  <li><Link to="/awards">Awards</Link></li>
  <li><Link to="/contact-us">Contact Us</Link></li>
  <li><Link to="/career">Careers</Link></li>
</ul>
          </div>
          <div className="footer-column">
            <h4>Get in Touch</h4>
            <ul>
              <li>
                <img src={location} alt="footer" />
                Singapore Security Force Pte Ltd <br />
                8 Burn Rd, #15-14 Trivex <br />
                Singapore 369977
              </li>
              <li>
                <img src={contact} alt="footer" />
               +65 8215 0399
              </li>
              <li>
                <img src={mail} alt="footer" />
                hr@singaporesecurityforce.com
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          <span>
            Copyrights © {new Date().getFullYear()} - Singapore Security Force -
            All Rights Reserved
          </span>{" "}
          | +65 8215 0399 |{" "}
          {/* <a href="#test">Terms of Service</a> | <a href="#test">Privacy Policy</a> */}
        </p>
      </div>
    </footer>
  );
}
